import styles from './buttonContainer.module.scss';
import ButtonComponent from '../../common/buttons/ButtonComponent/ButtonComponent';
import { buttonVariants } from '../../common/buttons/types';

export default function ButtonContainer({
  primaryText,
  secondaryText,
  back,
  actionCall,
  disabledPrimary = false,
  disabledSecondary = false
}) {
  return (
    <div className={styles.buttonContainer}>
      <ButtonComponent variant={buttonVariants.SECONDARY} text={primaryText} disabled={disabledPrimary} action={back} />
      <ButtonComponent
        variant={buttonVariants.PRIMARY}
        text={secondaryText}
        disabled={disabledSecondary}
        action={actionCall}
      />
    </div>
  );
}
